<template>
  <div>
    <div
      v-if="isExpandTag"
      class="flex-1 py-2">
      <div class="d-flex align-items-center px-2">
        <el-input
          placeholder="Tìm thẻ cần gắn"
          v-model="searchTagName"
          size="small"
          @change="changeTagName">
          <template slot="prepend">
            <el-select
              class="flex-1"
              @change="changeTagOpt"
              v-model="selectTagOpt"
              placeholder="Chọn tag"
              size="small"
              style="width: 140px">
              <el-option
                v-for="tag in tagOpt"
                :key="tag.val"
                :label="tag.key + ' (' + getTagCount(tag.val) + ') '"
                :value="tag.val"></el-option>
            </el-select>
          </template>
        </el-input>
        <div
          class="ms-2 pointer"
          @click="isExpandTag = false">
          <IconV2 name="v2-close" />
        </div>
      </div>
      <div class="p-1 mt-2 border-bottom border-top">
        <div
          class="p-1 d-flex justify-content-start flex-wrap"
          style="overflow-y: auto; max-height: 200px">
          <div
            v-for="item in listTagView"
            :key="item.id"
            @click="addOrRemoveTag(item)">
            <TagV2
              :data="item"
              :inactive="!isSelected(item)"
              :item="item"
              :selected="isSelected(item)"
              :is-button="true" />
          </div>
        </div>
      </div>
    </div>
    <div class="d-flex px-2 ms-1 pt-2 border-bottom">
      <el-tooltip
        effect="dark"
        :content="isExpandTag ? 'Thu hẹp' : 'Mở rộng'"
        placement="top">
        <div
          class="z2-btn z2-btn-outline z2-btn-rounded me-1"
          @click="onExpandTag">
          <i
            class="font-12 fw-bold"
            :class="isExpandTag ? 'el-icon-arrow-down' : 'el-icon-arrow-up'"></i>
        </div>
      </el-tooltip>
      <el-tooltip
        effect="dark"
        content="Thêm tag"
        placement="top">
        <div
          class="z2-btn z2-btn z2-btn-rounded me-1"
          @click="onAddTag">
          <i class="el-icon-plus font-12 fw-bold"></i>
        </div>
      </el-tooltip>

      <div
        class="d-flex align-items-center scroll-horizontal"
        :style="{ 'max-width': `calc(100vw - ${isExpand ? '744px' : '444px'})` }">
        <div
          v-for="tag in tagsActive"
          :key="tag.id"
          @click="addOrRemoveTag(tag)">
          <TagV2 :data="tag" />
        </div>

        <div
          v-for="tag in tagsInactive"
          :key="tag.id"
          @click="addOrRemoveTag(tag)">
          <TagV2
            :data="tag"
            :inactive="true" />
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import TagV2 from "./TagV2.vue";
import { removeVietnameseTones } from "../lib/text-utils";

export default {
  props: ["isExpand", "conversation"],
  components: {
    TagV2,
  },
  data() {
    return {
      tagOpt: [
        { key: "Tất cả tag", val: 0 },
        { key: "Tag chỉ định", val: 1 },
        { key: "Tag thường", val: 2 },
      ],
      isExpandTag: false,
      selectTagOpt: 0,
      searchTagName: "",
      tags: [],
      tagView: [],
    };
  },
  computed: {
    tagsActive() {
      return this.app.tags.filter((tag) => {
        const tagInConversation = this.conversation.tags.find((t) => t.id === tag.id);
        return tagInConversation ? true : false;
      });
    },
    tagsInactive() {
      return this.app.tags.filter((tag) => !this.tagsActive.includes(tag));
    },
    listTagView() {
      let view = [];
      switch (this.selectTagOpt) {
        case 0: {
          view = this.tagView;
          break;
        }
        case 1: {
          view = this.tagView.filter((p) => p.assign);
          break;
        }
        case 2: {
          view = this.tagView.filter((p) => !p.assign);
          break;
        }
      }

      if (this.searchTagName) {
        view = view.filter(
          (tag) =>
            removeVietnameseTones(tag.name.toLowerCase()).includes(this.searchTagName.toLowerCase()) ||
            tag.name.toLowerCase().includes(this.searchTagName.toLowerCase())
        );
      }

      return view;
    },
  },
  methods: {
    onExpandTag() {
      this.isExpandTag = !this.isExpandTag;
      this.tagView = JSON.parse(JSON.stringify(this.app.tags));
      this.$bus.$emit("onExpandTag", this.isExpandTag);
    },
    isSelected(item) {
      if (this.conversation.id) {
        let it = this.conversation.tags.filter((t) => t.id == item.id);
        if (it != null && it.length > 0) return true;
      }
      return false;
    },
    getTagCount(valueOption) {
      switch (valueOption) {
        case 0: {
          return this.app.tags.length;
        }
        case 2: {
          return this.app.tags.filter((t) => !t.assign).length;
        }
        case 1: {
          return this.app.tags.filter((t) => t.assign).length;
        }
        default:
          return 0;
      }
    },
    changeTagOpt() {
      // if (this.selectTagOpt == 0) {
      //   this.tagView = this.app.tags;
      // } else if (this.selectTagOpt == 1) {
      //   this.tagView = this.app.tags.filter((p) => p.assign);
      // } else {
      //   this.tagView = this.app.tags.filter((p) => !p.assign);
      // }
    },
    changeTagName() {
      // let view = [];
      // switch (this.selectTagOpt) {
      //   case 0: {
      //     view = this.app.tags;
      //     break;
      //   }
      //   case 1: {
      //     view = this.app.tags.filter((p) => p.assign);
      //     break;
      //   }
      //   case 2: {
      //     view = this.app.tags.filter((p) => !p.assign);
      //     break;
      //   }
      // }
      // if (this.searchTagName) {
      //   view = view.filter((tag) => removeVietnameseTones(tag.name).includes(this.searchTagName));
      // }
      // this.tagView = JSON.parse(JSON.stringify(view));
    },
    onAddTag() {
      this.$router.push("/setting#tag");
      // const routeData = this.$router.resolve("/setting#tag");
      // window.open(routeData.href, "_blank");
    },
    addOrRemoveTag(tag) {
      let request = {
        conversationId: this.conversation.id,
        tagId: tag.id,
      };
      this.$http.post("/api/conversation/tag", request).then((resp) => {
        this.conversation.tags = resp.data.tags;
        this.$bus.$emit("tagChanged", resp.data);
      });
    },
  },
};
</script>

<style>
</style>